import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

export const BirthdayFrame: React.FC<{ children: React.ReactNode }> = ({
    children,
}) => {
    const { t } = useTranslation();

    return (
        <Box display="flex" flexDirection="column" width="100%">
            <Box display="flex" justifyContent="center">
                <Typography variant="body2" color="textPrimary">
                    ꧁ <span>🎂</span> {t('Messages.Birthday')} <span>🎂</span> ꧂
                </Typography>
            </Box>
            <Box mb={2} mt={2}>
                {children}
            </Box>

            <Box
                display="flex"
                justifyContent="center"
                mb={1}
                style={{ gap: 15 }}
            >
                <span>🎈</span>
                <span>🎂</span>
                <span>🎉</span>
                <span>🥳</span>
                <span>🎁</span>
            </Box>

            <Box display="flex" justifyContent="center">
                <Typography variant="body2" color="secondary" align="center">
                    {t('Messages.BirthdayMessage')}
                </Typography>
            </Box>
        </Box>
    );
};
